/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOneGhost from 'DesignSystem/TysiaSelectOneGhost/index'
import TysiaSelectOneGhostArrow from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostArrow/index'
import TysiaSelectOneGhostContent from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostContent/index'
import TysiaSelectOneGhostIcon from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostIcon/index'
import TysiaSelectOneGhostLabel from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import Tysiav2UserSingleCircle from 'DesignSystem/Svgs/Tysiav2UserSingleCircle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Recipient/Content",
  onChange
  
}) {
let responsiblePartiesValueData = fromData.useDataValue({ viewPath,
context: 'responsible_parties',
})
let letterRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'recipient_id',
})
let letterRecipientIdChangeData = fromData.useDataChange({ viewPath,
context: 'letter',
path: 'recipient_id',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaSelectOneGhost
  viewPath={`${viewPath}/TysiaSelectOneGhost`}
 placeholder="Recipient"
 alignSelf="auto"
 data="responsible_parties"
 from={responsiblePartiesValueData}
 data="letter.recipient_id"
 value={letterRecipientIdValueData}
 onChange={letterRecipientIdChangeData}
 keepFilter={true}
>
{childProps => (
<TysiaSelectOneGhostContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneGhostIcon
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostIcon`}
>
{childProps => (
<Tysiav2UserSingleCircle
{...childProps}
  viewPath={`${viewPath}/Tysiav2UserSingleCircle`}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaSelectOneGhostIcon>
<TysiaSelectOneGhostLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostLabel`}
/>
<TysiaSelectOneGhostArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneGhostContent>
)}
</TysiaSelectOneGhost>
{children}
</React.Fragment>)
}